/**
 * The BCP-47 tag to hand to `Intl.*` for one of this app's locales.
 *
 * <p>They are the same string for every locale but one. The `sr-RS` bundle is
 * written mostly in LATIN script ("Radnja", "Ime", "Prezime"; a minority of
 * its values — some computed guest columns, group headings — are Cyrillic, a
 * bundle inconsistency of its own), but ICU's default script for `sr-RS` is
 * Cyrillic, so `Intl.ListFormat("sr-RS")`
 * joins Latin words with a Cyrillic "и" ("Ime, Prezime и Prijava" — observed
 * on node 26 / V8). `sr-Latn-RS` says "i". Mapped here once, so no caller has
 * to know; anything else passes through untouched.
 */
const INTL_LOCALE_OVERRIDES: Record<string, string> = {
  "sr-RS": "sr-Latn-RS",
};

export function intlLocaleOf(locale: string): string {
  return Object.prototype.hasOwnProperty.call(INTL_LOCALE_OVERRIDES, locale)
    ? INTL_LOCALE_OVERRIDES[locale]
    : locale;
}
